import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Accordion = function Accordion() {
  return import('~/components/molecules/Accordion.vue');
};

export default {
  name: 'NavItemFolders',
  components: {
    Accordion: Accordion
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};